// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
.hamburger-container {
  position: relative;
  display: none;
  height: 100%;
  /*Adding Mobile styles*/
}
.hamburger-container ul {
  margin: 0;
  padding: 0;
}
.hamburger-container li {
  text-align: center;
  list-style-type: none;
  border-bottom: 1px solid var(--border-color);
}
.hamburger-container li:first-child {
  border-top: 1px solid var(--border-color);
}
.hamburger-container li a {
  color: var(--color-fg);
  text-decoration: none;
}
.hamburger-container li a:hover {
  background-color: var(--hover-bg);
}
@media (max-width: 767px) {
  .hamburger-container {
    display: block;
  }
}

.hamburger {
  color: var(--color-fg);
  font-size: 1.2rem;
  position: relative;
  cursor: pointer;
  height: 100%;
  top: 50%;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
}

.hamburger span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: var(--color-fg);
  border-radius: 15px;
  opacity: 1;
  left: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
}

.hamburger span:nth-child(1) {
  top: -12px;
}

.hamburger span:nth-child(2), .hamburger span:nth-child(3) {
  top: -6px;
}

.hamburger span:nth-child(4) {
  top: 0px;
}

.hamburger.open span:nth-child(1) {
  top: 18px;
  width: 0%;
  left: 50%;
}

.hamburger.open span:nth-child(2) {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

.hamburger.open span:nth-child(3) {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.hamburger.open span:nth-child(4) {
  top: 18px;
  width: 0%;
  left: 50%;
}

.menu {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.4s ease-out;
  position: absolute;
  top: 50px;
  background-color: var(--color-bg);
  width: 100vw;
  left: -8px;
}
.menu .NavLinks {
  flex-direction: column;
  gap: 0;
}
.menu .NavLinks a {
  display: block;
  border-bottom: 1px solid var(--border-color);
  padding: 0.8rem;
}

.menu.show {
  max-height: 240px; /* adjust as needed */
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/HamburgerMenu.scss"],"names":[],"mappings":"AAAA,0BAAA;ACEA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EAyBA,uBAAA;AAxBJ;AACI;EACI,SAAA;EACA,UAAA;AACR;AACI;EACI,kBAAA;EACA,qBAAA;EACA,4CAAA;AACR;AACQ;EACI,yCAAA;AACZ;AAEQ;EACI,sBAAA;EACA,qBAAA;AAAZ;AAEY;EACI,iCAAA;AAAhB;ADpBE;ECHF;IA8BQ,cAAA;EAHN;AACF;;AAMA;EACI,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,+BAAA;EACA,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,iCAAA;EACA,+BAAA;EACA,4BAAA;AAHJ;;AAME;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,OAAA;EACA,+BAAA;EACA,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,qCAAA;EACA,kCAAA;EACA,gCAAA;EACA,6BAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;;AAMA;EACI,SAAA;AAHJ;;AAMA;EACI,QAAA;AAHJ;;AAMA;EACI,SAAA;EACA,SAAA;EACA,SAAA;AAHJ;;AAMA;EACI,gCAAA;EACA,6BAAA;EACA,2BAAA;EACA,wBAAA;AAHJ;;AAMA;EACI,iCAAA;EACA,8BAAA;EACA,4BAAA;EACA,yBAAA;AAHJ;;AAMA;EACI,SAAA;EACA,SAAA;EACA,SAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,SAAA;EACA,iCAAA;EACA,YAAA;EACA,UAAA;AAHJ;AAKI;EACI,sBAAA;EACA,MAAA;AAHR;AAKQ;EACI,cAAA;EACA,4CAAA;EACA,eAAA;AAHZ;;AASA;EACI,iBAAA,EAAA,qBAAA;AANJ","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@use '../styles';\n\n.hamburger-container {\n    position: relative;\n    display: none;\n    height: 100%;\n\n    ul {\n        margin: 0;\n        padding: 0;\n    }\n    li {\n        text-align: center;\n        list-style-type: none;\n        border-bottom: 1px solid var(--border-color);\n        \n        &:first-child {\n            border-top: 1px solid var(--border-color);\n        }\n\n        a {\n            color: var(--color-fg);\n            text-decoration: none;\n\n            &:hover {\n                background-color: var(--hover-bg);\n            }\n        }\n    }\n\n    /*Adding Mobile styles*/\n    @include styles.mobile {\n        display: block;\n    }\n}\n\n.hamburger {\n    color: var(--color-fg);\n    font-size: 1.2rem;\n    position: relative;\n    cursor: pointer;\n    height: 100%;\n    top: 50%;\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease-in-out;\n    -moz-transition: .5s ease-in-out;\n    -o-transition: .5s ease-in-out;\n    transition: .5s ease-in-out;\n  }\n  \n  .hamburger span {\n    display: block;\n    position: absolute;\n    height: 2px;\n    width: 100%;\n    background: var(--color-fg);\n    border-radius: 15px;\n    opacity: 1;\n    left: 0;\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .25s ease-in-out;\n    -moz-transition: .25s ease-in-out;\n    -o-transition: .25s ease-in-out;\n    transition: .25s ease-in-out;\n  }\n\n.hamburger span:nth-child(1) {\n    top: -12px;\n}\n\n.hamburger span:nth-child(2),.hamburger span:nth-child(3) {\n    top: -6px;\n}\n\n.hamburger span:nth-child(4) {\n    top: 0px;\n}\n\n.hamburger.open span:nth-child(1) {\n    top: 18px;\n    width: 0%;\n    left: 50%;\n}\n\n.hamburger.open span:nth-child(2) {\n    -webkit-transform: rotate(45deg);\n    -moz-transform: rotate(45deg);\n    -o-transform: rotate(45deg);\n    transform: rotate(45deg);\n}\n\n.hamburger.open span:nth-child(3) {\n    -webkit-transform: rotate(-45deg);\n    -moz-transform: rotate(-45deg);\n    -o-transform: rotate(-45deg);\n    transform: rotate(-45deg);\n}\n\n.hamburger.open span:nth-child(4) {\n    top: 18px;\n    width: 0%;\n    left: 50%;\n}\n\n.menu {\n    overflow: hidden;\n    max-height: 0;\n    transition: max-height 0.4s ease-out;\n    position: absolute;\n    top: 50px;\n    background-color: var(--color-bg);\n    width: 100vw;\n    left: -8px;\n\n    .NavLinks {\n        flex-direction: column;\n        gap: 0;\n\n        a {\n            display: block;\n            border-bottom: 1px solid var(--border-color);\n            padding: 0.8rem;\n        }\n    }\n\n}\n\n.menu.show {\n    max-height: 240px; /* adjust as needed */\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
